import { MapPin } from 'lucide-react';
import { getStoreMapUrls } from './getStoreMapUrls';
import type { ContactStore } from './contactHours';

interface ContactStoreMapProps {
  store: ContactStore;
}

export function ContactStoreMap({ store }: ContactStoreMapProps) {
  const place = store.place;
  const { embedUrl, directionsUrl } = getStoreMapUrls(place);
  if (!embedUrl) return null;

  return (
    <div className="wl6-contact-store__map-block">
      <div className="wl6-contact-store__map">
        <iframe
          title={`Mapa — ${store.company || 'Loja'}`}
          src={embedUrl}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </div>
      {directionsUrl && (
        <a
          href={directionsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="wl6-contact-store__map-link"
        >
          <MapPin className="h-4 w-4" />
          Como chegar
        </a>
      )}
    </div>
  );
}
